/*jshint camelcase:false*/
/*global window*/
/** CommonJS module shims for JavaScript libraries and objects attached to the
 browser's global 'window' object. The idea is to provide a single interface
 to the browser's global objects to reduce browser-specific couplings.

 Any shim specified in here can be "imported" using the CommonJS module
 pattern with 'require', e.g., in a CommonJS module, you can access jQuery
 like so:

 var $ = require( 'rei-browser-shim' ).jQuery;
 */
const win = typeof window !== 'undefined' ? window : {};

// Browser API
module.exports = {
    win:          win,
    jQuery:       win.jQuery || {},
    rei:          win.rei || {},
    isProduction: ( win.rei && win.rei.session ) ? win.rei.session.isProduction : undefined
};
